import { Handle, Position, useConnection, useReactFlow, useStore, useUpdateNodeInternals } from '@xyflow/react';
import './ApperServiceBox.css'
import { useEffect, useState } from 'react';
import { ContextMenu } from '../../../../components/contextMenu/contextMenu';


export default function ServiceBox({ data, id }) {
  const connection = useConnection();
  const updateNodeInternals = useUpdateNodeInternals();


  const edges = useStore((state) => state.edges);

  const isTarget = connection.inProgress && connection.fromNode && connection.fromNode.id !== `${data.id}`;

  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [connect, setConnect] = useState(false)

    const handleContextMenu = (e) => {
        e.preventDefault();
        const rect = e.target.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        setMenuPosition({ x: x , y: y});
        setShowMenu(true);
    };

  useEffect(() => {
    updateNodeInternals(id);
  }, [connect, id, updateNodeInternals]);

   useEffect(() => {
    setConnect(false)
    
  }, [edges.length]);

  useEffect(() => {
        document.addEventListener("click", (e)=>{setShowMenu(false)});
        return () => {
            document.removeEventListener("click", (e)=>{setShowMenu(false)});
        };
        }, []);

  return (
    <div className="customNode">
      <div
        className="customNodeBody apperview-service-box glassmorphism" onContextMenu={handleContextMenu} 
      >
            <div id={data.id}>
                <h1>{data.serviceInfo.service_name}</h1>
            </div>

        {showMenu && (
              <ContextMenu menuPosition={menuPosition} options={[
                  {
                      onClick: (e)=>{e.preventDefault();setConnect(true);setShowMenu(false)},
                      name: "connect"
                  }
              ]}/>
          )}
        {  (( !connection.inProgress) && (
          <Handle
            className="customHandle"
            position={Position.Right}
            isConnectable={connect}
            type="source"
          />
        ))}
        {(true) && (
          <Handle className="customHandle" position={Position.Left} type="target" isConnectableStart={false} />
        )}
      </div>
    </div>
  );
}
